module.exports = __webpack_public_path__ + "media/images/lb/680-d888330b53f09d7ca611397645d6f3e9.svg";